import React, {useState} from 'react';
import {Grid, Typography, withStyles} from '@material-ui/core';
import Layout from '../../components/Layout';
import i18n from '../../i18n';
import Toolbar from '../../components/Toolbar/Toolbar';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TowLine from '../../components/Text/TwoLine';
import Paper from '@material-ui/core/Paper';
import {withPaginator, Pagination} from '../../components/Pagination';
import TableRowClickable from '../../components/Form/TableRowClickable';
import TableCellSortable, {xOrder} from "../../components/Form/TableCellSortable";
import SearchForm from "../../components/Contacts/SearchForm";
import EllipsisWithTooltip from "../../components/Formater/EllipsisWithTooltip";
import Tooltip from "@material-ui/core/Tooltip";
import JournalIndexButton from "../../components/Form/JournalIndexButton";
import PrintDialog from "../../components/Building/Dialogs/PrintDialog";
import _ from "lodash";
import FormRadio from "../../components/Form/FormRadio";

const BuildingsIndex = ({classes, items: buildings, search, completed, message}) => {

    const {column, order, filter} = search;
    let paramsQuery = (filter ? '&filter=' + filter : '');
    let searchQuery = `/construction`;
    const params = {};
    if(completed) {
        params.completed = completed;
    }
    if (column) {
        params.column = column;
        //paramsQuery += '&column=' + column;
    }
    if (order) {
        params.order = order;
        //paramsQuery += '&order=' + order;
    }

    if(message) {
        swal({
            title: i18n.get('site-journal.alert.title_' + message.type),
            text: i18n.get('site-journal.alert.text_' + message.type,
                { date:message.date, user:message.user }
            ),
            icon: "warning",
            dangerMode: true,
        });
    }

    let items = [];
    window.can('buildings.create') && !parseInt(completed) && items.push( {
        icon: 'add',
        text: i18n.get('building.add'),
        href: `/construction/create`,
        size: 'small',
    } );

    /*** print dialog state */
    const [open, setOpen] = useState(false);
    const [building,setBuilding] = useState(null);
    const [filterConstruction, setFilterConstruction] = useState(parseInt(completed));

    const handleOpen = (id) => {
        let building = _.find(buildings,{id:id});
        setBuilding(building);
        setOpen(true);
    };
    const handleClose = () => {
        setBuilding(null);
        setOpen(false);
    }

    const handleFilter = () => {
        const value = filterConstruction ? 0 : 1;
        setFilterConstruction(value);
        window.location = searchQuery + '?' + 'completed=' + value;
    };

    const viewOptions = [
        {label:i18n.get('building.actions.incomplete_buildings'), value:'false'},
        {label:i18n.get('building.actions.completed_buildings'), value:'true'},
    ];

    return (
        <Layout>
            <Toolbar
                disableGutters
                title={i18n.get('building.construction_project')}
                subtitle={''}
                items={items}
            />
            <SearchForm url={searchQuery} params={params} {...search} />
            <Paper className={classes.paper}>
                {window.can('buildings.create') && (
                    <Grid container direction={'row'} justify={'center'} spacing={8}>
                        <FormRadio
                            name={'completed'}
                            value={!!filterConstruction}
                            options={viewOptions}
                            onChange={handleFilter}
                            row
                            style={{margin:0}}
                        />
                    </Grid>
                )}
                {!buildings || !buildings.length && (
                    <div style={{width: '100%', borderTop: '1px solid rgba(0,0,0,0.12)', paddingTop: 10, fontSize:'0.875rem'}}>{'No Construction Project found!'}</div>
                )}
                {buildings && buildings.length > 0 && (
                    <Table className={classes.list}>
                        <TableHead>
                            <TableRow>
                                <TableCellSortable style={{ width:120 }}
                                                   action={`/construction?completed=`
                                                       + completed
                                                       + `&column=cost_center.number&order=${xOrder(order)}`
                                                       + paramsQuery
                                                   }
                                                   active={column === 'cost_center.number'}
                                                   order={order}
                                >
                                    {i18n.get('building.cost_center')}
                                </TableCellSortable>
                                <TableCellSortable
                                    action={`/construction?completed=`
                                        + completed
                                        + `&column=name&order=${xOrder(order)}`
                                        + paramsQuery
                                    }
                                    active={column === 'name'}
                                    order={order}
                                >
                                    {i18n.get('building.construction_project_buildings')}
                                </TableCellSortable>
                                <TableCellSortable
                                    action={`/construction?completed=`
                                        + completed
                                        + `&column=city&order=${xOrder(order)}`
                                        + paramsQuery
                                    }
                                    active={column === 'city'}
                                    order={order}
                                >
                                    {i18n.get('building.address')}
                                </TableCellSortable>
                                {window.can('buildings.create') && (
                                    <TableCell scope="col" align={'center'}>
                                        {i18n.get('building.actions.self')}
                                    </TableCell>
                                )}
                                {window.can('site_journals.view') && (
                                    <TableCell scope="col" align={'center'}>
                                        {i18n.get('site-journal.site_journal')}
                                    </TableCell>
                                )}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {buildings.map( (building, idx) => (
                                <TableRowClickable
                                    key={`building_`+idx}
                                    action={
                                        window.hasRole('officer_journal')
                                            ? '/construction/' + building.id + '/site-journal'
                                            : null
                                    }
                                >
                                    <TableCell>
                                        {building.cost_center && (
                                            <Typography component="h6">
                                                <Tooltip title={building.cost_center.name}>
                                                    <span>{building.cost_center.number}</span>
                                                </Tooltip>
                                            </Typography>
                                        )}
                                    </TableCell>
                                    <TableCell>
                                        <Typography component="h6">
                                            <EllipsisWithTooltip>
                                                {building.name && building.name}
                                                {!building.parent && (' (' + building.children.length + ')')}
                                            </EllipsisWithTooltip>
                                        </Typography>
                                        <TowLine sub={building.parent && building.parent.name}/>
                                    </TableCell>
                                    <TableCell>
                                        <Typography component="h6">
                                            <EllipsisWithTooltip>
                                                {building.city}, {building.street} {building.number}
                                            </EllipsisWithTooltip>
                                        </Typography>
                                    </TableCell>
                                    {window.can('buildings.create') && (
                                        <TableCell style={{cursor:'default'}} align={'center'}
                                                   onClick={e => { e.stopPropagation('all'); }}>
                                            <IconButton
                                                className={classes.action}
                                                component="a"
                                                href={`/construction/${building.id}`}
                                            >
                                                <Icon>find_in_page</Icon>
                                            </IconButton>

                                            <IconButton
                                                component="a"
                                                href={`/construction/${building.id}/edit`}
                                            >
                                                <Icon>edit</Icon>
                                            </IconButton>
                                        </TableCell>
                                    )}
                                    {window.can('site_journals.view') && (
                                        <TableCell style={{cursor:'default'}}
                                                   onClick={e => { e.stopPropagation('all'); }} align={'center'}>
                                            {!building.parent  &&
                                                <React.Fragment>
                                                    {window.can('site_journals.print') && (
                                                        <React.Fragment>
                                                            <IconButton
                                                                component="a"
                                                                className={classes.action}
                                                                onClick={() => handleOpen(building.id)}
                                                                icon='print'
                                                                disabled={!building.journals_count}>
                                                                <Icon>{'print'}</Icon>
                                                            </IconButton>
                                                            <JournalIndexButton
                                                                className={classes.action}
                                                                href={`/construction/${building.id}/site-journal`}
                                                                icon='list'
                                                                disabled={!building.journals_count}
                                                            />
                                                            {!building.completed && (<JournalIndexButton
                                                                className={classes.action}
                                                                href={`/construction/${building.id}/site-journal/report/problems`}
                                                                icon='report_problem'
                                                                disabled={!building.journals_count}
                                                            />)}
                                                        </React.Fragment>
                                                    )}
                                                    {!building.completed && (<JournalIndexButton
                                                        href={`/construction/${building.id}/site-journal/create`}
                                                        icon='add'
                                                    />)}
                                                </React.Fragment>
                                            }
                                        </TableCell>
                                    )}
                                </TableRowClickable>
                            ))}
                        </TableBody>
                        <Pagination colSpan={5} classes={{spacer: "none"}}/>
                    </Table>
                )}
            </Paper>
            {building && (
                <PrintDialog
                    open={open}
                    handleClose={handleClose}
                    building={building}
                />
            )}
        </Layout>
    );
};


const styles = theme => ({
    span: {
        display: 'inline',
        margin: '0 5px',
    },
    paper: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            marginTop: theme.spacing.unit * 6,
            marginBottom: theme.spacing.unit * 6,
            padding: theme.spacing.unit * 3,
        },
    },
    list: {
        "& tr": {
            height:40,
        },
        "& td" : {
            paddingTop:0,
            paddingBottom:0,
        },
        "& a": {
            padding:2,
        }
    },
    action: {
        marginRight:15,
    }
});


export default withStyles(styles)(
    withPaginator('buildings')(BuildingsIndex)
);

